import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const StoryOverviewPage = lazy(
  () =>
    import('./StoryOverviewPage.eager').then(mod => ({
      default: mod.StoryOverviewPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
